import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getIndustryReportUrl,
  getMonthlyLendingUrl,
  getOverdueReportgUrl,
  getUserRepaymentsReportUrl,
  getManualPaymentSyncUrl,
  getManualSyncStatusUrl,
  getCustomerDetilsReportUrl,
  getLTVReportUrl,
  getIndustryInvoiceDetailsUrl,
  getKpiReportsDataURL,
  getKpiReportsModalDataURL,
  getKpiReportsGenerateDownloadDataURl,
  getKpiGeneratedReportsDataURL,
  getRefreshKpiReportURL,
  getRefreshKpiReportDataStatusURL,
  getMonthlyComissionUrl,
  getMonthlyComissionDownloadUrl,
  getReportFilesDownloadUrl,
  getAiTrainingDataGenerateRequestUrl,
  getAiLatestStatusUrl
} from "../utils/constants/apiEndPoints";
import { showToast } from "../utils/utils";
import { showToastType } from "../utils/constants/appConstants";
import privateAxios from "../utils/axiosPrivate";
import { commonErrMsg, customerRepoDtls } from "../locales/en";

const initialState = {
  reportData: {},
  loading: false,
  LTVloading: false,
  paymentReportData: {},
  customerLoader: false,
  kpiReportDataLoader: false,
  kpiReportModalDataLoader: false,
  kpiGeneratedDataLoader: false,
  kpiDownloadDataLoader: false,
  kpiRefreshDataLoader: false,
  kpiRefreshErrorData: null,
  kpiRequestDataStatus: null,
  monthlyCommissionLoader: false,
  monthlyCommissionDownloadLoader: false,
  industrySectorLoader: false,
  aiRefreshDataLoader: false,
  aiRefreshErrorData: null,
  aiRequestDataStatus: {},
  showTopHideFilter: false,
  quoteIds: [],
  selectedUserAccountIds: [],
  userQuoteIdsSelected: []
};

const userReportsSlice = createSlice({
  name: "userReport",
  initialState,
  reducers: {
    setReportData(state, action) {
      state.reportData = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setLTVloader(state, action) {
      state.LTVloading = action.payload;
    },
    setCustomerLoader(state, action) {
      state.customerLoader = action.payload;
    },
    setKpiRequestDataStatus: (state, action) => {
      state.kpiRequestDataStatus = action.payload;
    },
    setAiRequestDataStatus: (state, action) => {
      state.aiRequestDataStatus = action.payload;
    },
    setShowTopHideFilter(state, action) {
      state.showTopHideFilter = action.payload;
    },
    setSelectedReportData: (state, action) => {
      const {
        quoteIds,
        paymentIds,
        selectedUserAccountIds,
        userQuoteIdsSelected
      } = action.payload;

      state.quoteIds = quoteIds;
      state.paymentIds = paymentIds;
      state.selectedUserAccountIds = selectedUserAccountIds;
      state.userQuoteIdsSelected = userQuoteIdsSelected;
    }
  },
  extraReducers: (builder) => {
    // Handle RepaymentsReportData
    builder
      .addCase(getUserRepaymentsReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUserRepaymentsReport.fulfilled, (state, action) => {
        state.loading = false;
        state.paymentReportData = action.payload.data;
      })
      .addCase(getUserRepaymentsReport.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getIndustryInvoiceDetailsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getIndustryInvoiceDetailsThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(getIndustryInvoiceDetailsThunk.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getCustomerDetailsReport.pending, (state) => {
        state.customerLoader = true;
      })
      .addCase(getCustomerDetailsReport.fulfilled, (state, action) => {
        state.customerLoader = false;
        state.paymentReportData = action.payload.data;
      })
      .addCase(getCustomerDetailsReport.rejected, (state, action) => {
        state.customerLoader = false;

        const status = action.payload?.status;
        const errors = action.payload?.data?.errors || [];

        if (status === 404) {
          if (!errors.includes(customerRepoDtls?.errMsg?.item1)) {
            showToast(errors.join(", "), showToastType.error);
          }
        } else if (errors.length) {
          showToast(errors.join(", "), showToastType.error);
        } else {
          showToast(commonErrMsg.item2, showToastType.error);
        }
      })

      //Handle LTV Report
      .addCase(getLTVReportThunk.pending, (state) => {
        state.LTVloading = true;
      })
      .addCase(getLTVReportThunk.fulfilled, (state) => {
        state.LTVloading = false;
      })
      .addCase(getLTVReportThunk.rejected, (state, action) => {
        state.LTVloading = false;
        showToast(action.payload?.data?.message, showToastType.error);
      })

      //Handle getUserKPIReportData Report
      .addCase(getUserKPIReportData.pending, (state) => {
        state.kpiReportDataLoader = true;
      })
      .addCase(getUserKPIReportData.fulfilled, (state) => {
        state.kpiReportDataLoader = false;
      })
      .addCase(getUserKPIReportData.rejected, (state) => {
        state.kpiReportDataLoader = false;
      })

      //Handle getUserKPIReportModalData Report
      .addCase(getUserKPIReportModalData.pending, (state) => {
        state.kpiReportModalDataLoader = true;
      })
      .addCase(getUserKPIReportModalData.fulfilled, (state) => {
        state.kpiReportModalDataLoader = false;
      })
      .addCase(getUserKPIReportModalData.rejected, (state) => {
        state.kpiReportModalDataLoader = false;
      })

      .addCase(kpiReportsGenerateDownloadData.pending, (state) => {
        state.kpiDownloadDataLoader = true;
      })
      .addCase(kpiReportsGenerateDownloadData.fulfilled, (state, action) => {
        state.kpiDownloadDataLoader = false;
        showToast(action.payload?.data?.message, showToastType.success);
      })
      .addCase(kpiReportsGenerateDownloadData.rejected, (state, action) => {
        state.kpiDownloadDataLoader = false;
        const status = action.payload?.status;
        const errors = action.payload?.data?.errors || [];

        if (status === 404) {
          if (!errors.includes(customerRepoDtls?.errMsg?.item1)) {
            showToast(errors.join(", "), showToastType.error);
          }
        } else if (errors.length) {
          showToast(errors.join(", "), showToastType.error);
        } else {
          showToast(commonErrMsg.item2, showToastType.error);
        }
      })

      .addCase(getUserKPIGeneratedReportData.pending, (state) => {
        state.kpiGeneratedDataLoader = true;
      })
      .addCase(getUserKPIGeneratedReportData.fulfilled, (state) => {
        state.kpiGeneratedDataLoader = false;
      })
      .addCase(getUserKPIGeneratedReportData.rejected, (state) => {
        state.kpiGeneratedDataLoader = false;
      })

      .addCase(refreshKpiReportData.pending, (state) => {
        state.kpiRefreshDataLoader = true;
        state.kpiRefreshErrorData = null;
      })
      .addCase(refreshKpiReportData.fulfilled, (state) => {
        state.kpiRefreshDataLoader = false;
        state.kpiRefreshErrorData = null;
      })
      .addCase(refreshKpiReportData.rejected, (state, action) => {
        state.kpiRefreshDataLoader = false;
        const status = action.payload?.status;
        const errorsData = action.payload?.data?.errors || [];
        if (status === 400) {
          state.kpiRefreshErrorData = errorsData;
        } else {
          showToast(commonErrMsg.item2, showToastType.error);
        }
      })

      .addCase(getMonthlyCommissionReport.pending, (state) => {
        state.monthlyCommissionLoader = true;
      })
      .addCase(getMonthlyCommissionReport.fulfilled, (state) => {
        state.monthlyCommissionLoader = false;
      })
      .addCase(getMonthlyCommissionReport.rejected, (state, action) => {
        state.monthlyCommissionLoader = false;
        showToast(action.payload?.data?.message, showToastType.error);
      })

      .addCase(getMonthlyCommissionReportDownload.pending, (state) => {
        state.monthlyCommissionDownloadLoader = true;
      })
      .addCase(getMonthlyCommissionReportDownload.fulfilled, (state) => {
        state.monthlyCommissionDownloadLoader = false;
      })
      .addCase(getMonthlyCommissionReportDownload.rejected, (state, action) => {
        state.monthlyCommissionDownloadLoader = false;
        showToast(action.payload?.data?.message, showToastType.error);
      })

      .addCase(getIndustryReport.pending, (state) => {
        state.industrySectorLoader = true;
      })
      .addCase(getIndustryReport.fulfilled, (state) => {
        state.industrySectorLoader = false;
      })
      .addCase(getIndustryReport.rejected, (state, action) => {
        state.industrySectorLoader = false;
        showToast(action.payload?.data?.message, showToastType.error);
      })

      .addCase(refreshAiReportData.pending, (state) => {
        state.aiRefreshDataLoader = true;
        state.aiRefreshErrorData = null;
      })
      .addCase(refreshAiReportData.fulfilled, (state) => {
        state.aiRefreshDataLoader = false;
        state.aiRefreshErrorData = null;
      })
      .addCase(refreshAiReportData.rejected, (state) => {
        state.aiRefreshDataLoader = false;
        showToast(commonErrMsg.item2, showToastType.error);
      });
  }
});

// Async thunk to get Monthly report data
export const getMonthlyLendingReport = createAsyncThunk(
  "userReport/getMonthlyLendingReport",
  async ({ dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await privateAxios.post(getMonthlyLendingUrl);
      return response;
    } catch (error) {
      showToast(error.response.data.message, showToastType.error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
// Async thunk to get overdue report table data (NOT download)
export const getOverDueReport = createAsyncThunk(
  "userReport/getOverDueReport",
  async (payload, { dispatch }) => {
    try {
      dispatch(setLoading(true));

      const response = await privateAxios.get(getOverdueReportgUrl, {
        params: payload
      });

      return response;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        showToast(message, showToastType.error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);

// Async thunk to get Customer report data
export const getCustomerDetailsReport = createAsyncThunk(
  "userReport/getCustomerDetailsReport",
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setCustomerLoader(true));
      const response = await privateAxios.get(getCustomerDetilsReportUrl, {
        params: payload
      });

      return response;
    } catch (error) {
      return rejectWithValue(error);
    } finally {
      dispatch(setCustomerLoader(false));
    }
  }
);

// Async thunk to get LTV report data
export const getLTVReportThunk = createAsyncThunk(
  "userReport/getLTVReportThunk",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.post(getLTVReportUrl, payload);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Async thunk to get overdue report data
export const getIndustryReport = createAsyncThunk(
  "userReport/getIndustryReport",
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setLoading(true));
      const axiosConfig = {
        params: payload
      };

      const response = await privateAxios.get(
        getIndustryReportUrl,
        axiosConfig
      );
      dispatch(setReportData(response.data.data));
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

// Async thunk to get getIndustry InvoiceDetails
export const getIndustryInvoiceDetailsThunk = createAsyncThunk(
  "userReport/getIndustryInvoiceDetails",
  async (payload, { dispatch }) => {
    try {
      dispatch(setLoading(true));

      const response = await privateAxios.get(getIndustryInvoiceDetailsUrl, {
        params: payload
      });

      return response;
    } catch {
      // handle catch here;
    } finally {
      dispatch(setLoading(false));
    }
  }
);

// Generic file-download thunk for report files ✔
export const getReportFileDownload = createAsyncThunk(
  "userReport/getReportFileDownload",
  async ({ reportFileType, fileName }, { rejectWithValue }) => {
    try {
      const endpointUrl = getReportFilesDownloadUrl(reportFileType);
      const response = await privateAxios.get(endpointUrl, {
        responseType: "blob"
      });

      // Determine mime type and extension based on reportFileType when filename not provided
      let mime = "text/csv;charset=utf-8;";
      let ext = "csv";

      const upperType = (reportFileType || "").toUpperCase();
      if (upperType.includes("INVOICE")) {
        mime =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        ext = "xlsx";
      }

      const downloadName =
        fileName ||
        `${reportFileType ? reportFileType.toLowerCase() : "report"}`;

      // File download logic
      const blob = new Blob([response.data], { type: mime });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      // Optional: timestamp in file name
      const timestamp = new Date().toISOString().split("T")[0];
      link.setAttribute("download", `${downloadName}_${timestamp}.${ext}`);

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      return response;
    } catch (error) {
      if (error?.response?.data instanceof Blob) {
        try {
          const text = await error.response.data.text();
          const json = JSON.parse(text);
          showToast(json.message, showToastType.error);
        } catch {
          showToast(commonErrMsg.item2, showToastType.error);
        }
        return rejectWithValue(error.response);
      }

      const message = error?.response?.data?.message || error?.message;
      showToast(message, showToastType.error);
      return rejectWithValue(error.response);
    }
  }
);

// for user payments report
export const getUserRepaymentsReport = createAsyncThunk(
  "userReport/getUserRepaymentsReport",
  async (payload, { rejectWithValue }) => {
    try {
      const axiosConfig = {
        params: payload
      };
      const response = await privateAxios.get(
        getUserRepaymentsReportUrl,
        axiosConfig
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

// Check Xero Sync Status thunk
export const checkXeroSyncStatus = createAsyncThunk(
  "userReport/checkXeroSyncStatus",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.put(getManualSyncStatusUrl);
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

// Export ManualPaymentSync thunk
export const getManualPaymentSync = createAsyncThunk(
  "userActivityLog/getManualPaymentSync",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.post(
        getManualPaymentSyncUrl,
        payload
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

// for user KPI report
export const getUserKPIReportData = createAsyncThunk(
  "userReport/getUserKPIReportData",
  async (payload, { rejectWithValue }) => {
    try {
      const paramsConfig = {
        params: payload
      };
      const response = await privateAxios.get(
        getKpiReportsDataURL,
        paramsConfig
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

// for user KPI report
export const getUserKPIGeneratedReportData = createAsyncThunk(
  "userReport/getUserKPIGeneratedReportData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(getKpiGeneratedReportsDataURL);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

// for user KPI report
export const getUserKPIReportModalData = createAsyncThunk(
  "userReport/getUserKPIReportModalData",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.post(
        getKpiReportsModalDataURL,
        {
          ids: payload.ids,
          filterType: payload.filterType
        },
        {
          params: {
            page: payload.page,
            size: payload.size
          }
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const kpiReportsGenerateDownloadData = createAsyncThunk(
  "userManagement/kpiReportsGenerateDownloadData",
  async ({ payload }, { rejectWithValue }) => {
    try {
      const response = await privateAxios.post(
        getKpiReportsGenerateDownloadDataURl,
        payload
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const refreshKpiReportData = createAsyncThunk(
  "userManagement/refreshKpiReportData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await privateAxios.post(getRefreshKpiReportURL);
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const refreshKpiReportDataGet = createAsyncThunk(
  "userManagement/refreshKpiReportDataGet",
  async (_, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(getRefreshKpiReportDataStatusURL);
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const refreshAiReportData = createAsyncThunk(
  "userManagement/refreshAiReportData",
  async (reportFileType, { rejectWithValue }) => {
    try {
      const response = await privateAxios.post(
        getAiTrainingDataGenerateRequestUrl(reportFileType)
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const refreshAiReportDataGet = createAsyncThunk(
  "userManagement/refreshAiReportDataGet",
  async (reportFileType, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(
        getAiLatestStatusUrl(reportFileType)
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const getMonthlyCommissionReport = createAsyncThunk(
  "userReport/getMonthlyCommissionReport",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(getMonthlyComissionUrl, {
        params: payload
      });
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getMonthlyCommissionReportDownload = createAsyncThunk(
  "userReport/getMonthlyCommissionReportDownload",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(getMonthlyComissionDownloadUrl, {
        responseType: "blob",
        params: payload
      });
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const {
  setReportData,
  setLoading,
  setCustomerLoader,
  setLTVloader,
  setKpiRequestDataStatus,
  setAiRequestDataStatus,
  setShowTopHideFilter,
  setSelectedReportData
} = userReportsSlice.actions;
export default userReportsSlice.reducer;
